import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var quizListRes;
export const quizListTodo = createAsyncThunk('quizList', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'quiz/view_quiz_list',
            data: {
                "user_id": user_id.vemp_code,
                "dept_id": data.department,
                "status": data.status,
                "temp": data.temp,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return quizListRes = res.data
    } catch (error) {
        return quizListRes = error.response.data
    }
})


const quizListSlice = createSlice({
    name: 'quizList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(quizListTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('quizList', state.data)
            }
        });
        builder.addCase(quizListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default quizListSlice.reducer; 